import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    message: null,
    error: null,
    data: [],
};

const getPetTypesSlice = createSlice({
    name: "getPetTypes",
    initialState,
    reducers: {
        getPetTypesStart(state, payload) {
            state.loading = true;
            state.error = null;
            state.message = null;
        },

        getPetTypesSuccess(state, action) {
            state.loading = false;
            state.data = action?.payload;
            state.message = action.payload.message;
        },
        getPetTypesFailure(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.message = null;
        },
        clearError: (state) => {
            state.error = null;
        },
        clearMessage: (state) => {
            state.message = null;
        },
    },
});

export const {
    getPetTypesStart,
    getPetTypesSuccess,
    getPetTypesFailure,
    clearError,
    clearMessage,
} = getPetTypesSlice.actions;

export default getPetTypesSlice.reducer;
